<span class="loader-frame" [style.width.px]="effectiveSize()" [style.height.px]="effectiveSize()">
  <svg
    class="spinner"
    [class.spinner-dark]="theme() === 'dark'"
    [class.spinner-light]="theme() === 'light'"
    xmlns="http://www.w3.org/2000/svg"
    [attr.width]="effectiveSize()"
    [attr.height]="effectiveSize()"
    viewBox="0 0 48 48"
    fill="none"
    [attr.aria-hidden]="true"
    [style.animation-duration.ms]="duration()"
  >
    <g [attr.clip-path]="clipPathUrl">
      <g transform="matrix(-0.021 0.006 -0.00560849 -0.0196297 24 24)">
        <foreignObject x="-1634.99" y="-1634.99" width="3269.97" height="3269.97">
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            class="spinner-gradient"
            [style.background]="spinnerGradient()"
          ></div>
        </foreignObject>
      </g>
    </g>
    <path [attr.d]="spinnerPathD" />
    <defs>
      <clipPath [id]="clipPathId">
        <path [attr.d]="spinnerPathD" />
      </clipPath>
    </defs>
  </svg>
  <span class="loader-content">
    <ng-content></ng-content>
  </span>
</span>
